<template>
  <div class="jm-channel-select" v-if="!excludeDisable">
    <el-select
      v-bind="$attrs"
      v-for="(val, key) in channels"
      :key="key"
      v-model="channelModel[key]"
      class="jm-input135"
      @change="(v) => { getChannel(v, key); }"
      :ref="key"
      filterable
    >
      <el-option
        v-for="item in val"
        :label="item.name"
        :value="item.id"
        :key="item.id">
        <span :style="`color:${item.color};`">{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
  <div class="jm-channel-select" v-else>
    <span v-for="item in channelStr" :key="item.id" :style="`color:${item.color};margin-right:10px;`">{{ item.name }}</span>&nbsp;&nbsp;
  </div>
</template>

<script>

import lockr from 'lockr';
import { getChannelDataset } from '@/utils/utils.js';

export default {
  name: 'JmChannel',
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    excludeDisable: {
      type: Boolean,
      default: false,
    },
    isAll: {
      type: Boolean,
      default: true,
    },
    siteName: {
      type: String,
      default: '',
    },
    final: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cacheKey: 'channels',
      channelData: [],
      channelStr: [],
      channelModel: {
        custom_from: '',
        custom_from_sub: '',
        custom_from_thrid: '',
        custom_from_fourth: '',
        custom_from_fifth: '',
      },
      channels: {
        custom_from: [],
        custom_from_sub: [],
        custom_from_thrid: [],
        custom_from_fourth: [],
        custom_from_fifth: [],
      },
      inited: false,
      loading: true,
      channelFilter: []
    };
  },
  methods: {
    nextKey(key) {
      const keys = Object.keys(this.channels);
      if (key === '') {
        return keys[0];
      }
      for (let i = 0; i < keys.length; i++) {
        if (key === keys[i]) {
          let nextIndex = i + 1;
          return nextIndex === keys.length ? false : keys[nextIndex];
        }
      }
    },
    /**
     * 获取渠道数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise}
     */
    getChannelData() {
      return getChannelDataset();
    },
    /**
     * 验证缓存数据是否为最新，否则获取最新数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise}
     */
    getChannels() {
      const channels = lockr.get(this.cacheKey);
      if (!channels) {
        return Promise.resolve(this.getChannelData());
      }
      return this.getChannelData();
    },
    getChannelFilter() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/api_base/getChannelFilter',
        }).then(({ data }) => {
          if (this.excludeDisable || !this.isAll) {
            this.channelFilter = data;
            resolve('');
          }
        });
      });
    },
    /**
     * 获取渠道
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Number} pid
     * @param  {String} level
     * @return {Boolean}
     */
    getChannel(pid = 0, level = '') {
      const nextKey = this.nextKey(level);
      if (nextKey === false) {
        this.$emit('update:final', true);
        return true;
      }
      // console.log(this.channelFilter);
      const isMark = this.$hasPermission(154) && !this.$hasPermission(1);
      const markpid = [];
      this.channelData.forEach((item) => {
        if (item.level === 2 && item.pid === 7103) {
          markpid.push(item.id);
        }
      });
      if (this.channelFilter.length) {
        this.channels[nextKey] = this.channelData.filter((item) => {
          return item.pid === pid
            && (this.channelFilter.indexOf(item.id) !== -1 || this.filterMark(isMark, markpid, item, 3));
        });
      } else {
        this.channels[nextKey] = this.channelData.filter((item) => {
          return item.pid === pid
            && this.filterMark(isMark, markpid, item, 3);
        });
      }

      if (this.channels[nextKey].length < 1) {
        this.$emit('update:final', true);
      } else {
        this.$emit('update:final', false);
      }
      this.$emit('change', this.channelModel);
    },
    filterMark(isMark, markpid, item, level) {
      if (isMark && item.level === level && markpid.indexOf(item.pid) !== -1) {
        // 渠道在范围内需要判断默认推广人
        if (item.default_member !== this.$store.getters.userInfo.userid) {
          return false;
        }
      }
      return true;
    },
    /**
     * 重制子渠道选项内容
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {String} level [description]
     */
    resetSubChannel(level) {
      const key = this.nextKey(level);
      this.channelModel[key] = '';
      this.channels[key] = [];
    },
    resetSub(nV, oV, level) {
      if (nV !== oV && this.inited) {
        this.resetSubChannel(level);
        this.getChannel(nV, level);
      }
    },
    /**
     * 设置渠道焦点
     */
    focus(channelKey = 'custom_from') {
      this.$refs[channelKey][0].focus();
    }
  },
  mounted() {
    this.getChannelFilter();
    this.getChannels().then(({ channels }) => {
      this.channelData = channels.filter((item) => {
        if (this.isAll) {
          return true;
        }
        // 不设置channelFilter的人，全部显示
        if (this.channelFilter.length === 0) {
          return item.ch_status === 0
            && item.site_dic_key
            && item.site_dic_key.indexOf(this.siteName === '' ? process.env.VUE_APP_SITE_NAME : this.siteName) !== -1;
        }
        // if (item.site_dic_key) {
        //   console.log(item.site_dic_key.indexOf(process.env.VUE_APP_SITE_NAME));
        // }
        // return item.ch_status === 0; // 待渠道调整好之后再使用下面方法过滤平台
        // 设置过channelFilter的，显示channelFilter里面的值
        return item.ch_status === 0
          && item.site_dic_key
          && item.site_dic_key.indexOf(this.siteName === '' ? process.env.VUE_APP_SITE_NAME : this.siteName) !== -1
          && this.channelFilter.indexOf(item.id) !== -1;
      });
      let nextKey = '';
      let pid = 0;
      while (nextKey !== false) {
        this.getChannel(pid, nextKey);
        nextKey = this.nextKey(nextKey);
        pid = this.value[nextKey];
        if (!pid) {
          break;
        }
      }
      let list = {};
      channels.forEach((item) => {
        list[item.id] = Object.assign({}, item);
      });
      this.channelStr = [];
      Object.keys(this.value).forEach((key) => {
        if (this.value[key] && list[this.value[key]]) {
          this.channelStr.push(list[this.value[key]]);
        }
      });
      this.inited = true;
      this.channelModel = this.value;
    });
  },
  watch: {
    value(v) {
      this.channelModel = v;
    },
    'channelModel.custom_from'(v, ov) {
      this.resetSub(v, ov, 'custom_from');
    },
    'channelModel.custom_from_sub'(v, ov) {
      this.resetSub(v, ov, 'custom_from_sub');
    },
    'channelModel.custom_from_thrid'(v, ov) {
      this.resetSub(v, ov, 'custom_from_thrid');
    },
    'channelModel.custom_from_fourth'(v, ov) {
      this.resetSub(v, ov, 'custom_from_fourth');
    },
  },
};
</script>

<style>
  .jm-channel-select {
    display: inline-block;
  }
  .jm-channel-select .el-select {
    margin-right: 8px;
  }
  .jm-channel-select .el-select:last-of-type{
    margin-right: 0;
  }
</style>
